import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainer, FHEContainerScroll, FHEContainerForm, FHETitle, FHEDivider, FHEItemText, FHEButton } from 'data/components';
import { Toastr } from 'data/common';
import { FlagFr, FlagEn, FlagDe, SvgTicket, SvgUser } from 'data/common/iconsvg';
import { getProjectDetails } from '../../data/Projects/actions';

class ProjectDetails extends PureComponent {
    static propTypes = {
        getProjectDetails: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        profile: PropTypes.object.isRequired,
        project: PropTypes.object.isRequired,
        commercialAgent: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.getProjectDetails();
    }

    getProjectDetails = () => {
        const { getProjectDetails, match } = this.props;

        this.setState({ loading: true, error: null });
        getProjectDetails(match.params.projectId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    toCommercialAgent = () => {
        const { history, project } = this.props;
        return history.push({
            pathname: `/${history.environment}/commercialAgent/detail/${project.get('commercialAgentId')}`
        });
    };

    renderFlag(country) {
        switch (country) {
            case 'fr_FR':
                return <FlagFr />;
            case 'en_EN':
                return <FlagEn />;
            case 'de_DE':
                return <FlagDe />;
            default:
                return null;
        }
    }
    renderChildren = () => {
        const { loading } = this.state;
        const { project, commercialAgent, profile, classes, history } = this.props;
        return (
            <Fragment>
                <FHETitle title={project.get('label')} Icon={SvgTicket} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    loader={loading && project.get('firstname') === undefined}
                                    itemTitle={Translator.translate('general.table.column.firstname')}
                                    itemContent={project.get('firstname')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    loader={loading && project.get('lastname') === undefined}
                                    itemTitle={Translator.translate('general.table.column.lastname')}
                                    itemContent={project.get('lastname')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    loader={loading && project.get('gender') === undefined}
                                    itemTitle={Translator.translate('general.table.column.gender')}
                                    itemContent={Translator.translate(`general.gender.${project.get('gender')}`)}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.email')} itemContent={project.get('email')} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.price')}
                                    itemContent={`${project.get('price')} €`}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.priceFHE')}
                                    itemContent={`${project.get('priceFHE')} €`}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.surface')}
                                    itemContent={`${project.get('surface')} m²`}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.residents')}
                                    itemContent={project.get('residents')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.lastUpdate')}
                                    itemContent={project.get('lastUpdate')}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    <FHEDivider title={Translator.translate('general.commercialAgent')} IconComponent={SvgUser} />
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.firstname')}
                                    itemContent={commercialAgent.get('firstname')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.lastname')}
                                    itemContent={commercialAgent.get('lastname')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.email')}
                                    itemContent={commercialAgent.get('email')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.city')}
                                    itemContent={commercialAgent.get('city')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.phone')}
                                    itemContent={commercialAgent.get('phone')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.society')}
                                    itemContent={commercialAgent.get('society')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.language')}
                                    iconSimple={commercialAgent.get('language') ? this.renderFlag(commercialAgent.get('language')) : ''}
                                    itemContent={Translator.translate(`general.table.column.languages.${commercialAgent.get('language')}`)}
                                />
                            </Grid>

                            {(profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('commercialAgentDetails')) && (
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEButton
                                        className={classes.btnStyle}
                                        content={Translator.translate(`${history.environment}.project.toCommercialAgentDetails`)}
                                        clickFunction={this.toCommercialAgent}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </FHEContainerForm>
                </FHEContainerScroll>
            </Fragment>
        );
    };
    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;

        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getProjectDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const project = state.environments[history.environment].data.Projects.getIn(['list', props.match.params.projectId], new Map());
    const commercialAgentId = project.get('commercialAgentId') ? project.get('commercialAgentId').toString() : null;
    const commercialAgent = state.environments[history.environment].data.CommercialAgents.getIn(['list', commercialAgentId], new Map());
    return {
        profile: state.data.user,
        initialized: state.environments[history.environment].data.Projects.get('initialized'),
        project,
        commercialAgent
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    btnStyle: {
        color: '#EBEBEB',
        margin: '7px 0'
    },
    bgColor: {
        backgroundColor: '#EBEBEB'
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getProjectDetails }, dispatch)
    )(withStyles(styles, { withTheme: true })(ProjectDetails))
);



// WEBPACK FOOTER //
// ./environments/simulationenr/scenes/Project/details.js